module.exports = __webpack_public_path__ + "img/phone_bg.74ab781b.png";